const TitleBlockView = ({ properties, metadata }) => {
  return (
    <h1 className="documentFirstHeading csj-heading1">
      {(metadata || properties)['title'] || ''}
    </h1>
  );
};

export default TitleBlockView;
